import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';

import * as TagNames from './layouts.tagnames';
import classNames from 'classnames';

@customElement(TagNames.BodyContent)
export class AtlBodyContent extends LitElement {
    declare fillWidth: boolean;
    private _shouldCenter: boolean;

    static properties = {
        fillWidth: { type: Boolean, attribute: 'fill-width', reflect: true },
    };

    static styles = [
        ...getGlobalStyleSheets(),
        css`
            .body-content-centered {
                max-width: 1920px;
                margin: auto;
            }
        `,
    ];

    constructor() {
        super();
        this.fillWidth = false;
        this._shouldCenter = window.innerWidth > 1920;
    }

    connectedCallback(): void {
        super.connectedCallback();
        window.addEventListener("resize", this._handleResize);
    }

    disconnectedCallback(): void {
        window.removeEventListener("resize", this._handleResize);
        super.disconnectedCallback();
    }

    render() {
        return html`
            <main id="MainContent" role="main">
                <div 
                    id="MainContentBody" 
                    class=${classNames(
                        'body-content',
                        !this.fillWidth && this._shouldCenter && 'body-content-centered'
                    )}
                >
                    <slot></slot>
                </div>
            </main>
        `;
    }

    private _handleResize = () => {
        this._shouldCenter = window.innerWidth > 1920;
        this.requestUpdate();
    };
}
